import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { ASSISTANT_CHAT_HISTORY_URL, ASSISTANT_CHAT_SEND_URL } from '../constants';
import { AuthContext } from './AuthContext';

const ChatContext = createContext();

const ChatProvider = ({ children }) => {
  const [chatMenu, setChatMenu] = useState([]);
  const [chatMessage, setChatMessage] = useState([]);
  const [chatShow, setChatShow] = useState(false);
  const [showChatTime, setShowChatTime] = useState(new Date().toISOString());
  const [threadId, setThreadId] = useState(null);

  // ✅ Nuevo estado global
  const [responses, setResponses] = useState([]); 

  const { user } = useContext(AuthContext);

  // Cargar historial al iniciar o cuando cambia el usuario
  useEffect(() => {
    const fetchChatHistory = async () => {
      try {
        const response = await axios.get(ASSISTANT_CHAT_HISTORY_URL, {
          params: { userid: user?.IDalumno }
        });
        const menu = (response.data?.menu || []).reverse();
        setChatMenu(menu);
      } catch (error) {
        console.error('Error fetching chat history:', error.message);
      }
    };

    if (user?.IDalumno) {
      fetchChatHistory();
    }
  }, [user, showChatTime]);

  // Enviar mensaje
  const sendMessage = async (message, files = []) => {
    try {
      const formData = new FormData();
      formData.append("message", message);
      formData.append("userId", user.IDalumno);
      formData.append("time", new Date().toISOString()); // ← 📁 esto define la carpeta en S3

      if (threadId) {
        formData.append("threadId", threadId);
      }
      files.forEach(file => formData.append("files", file));

      const response = await axios.post(ASSISTANT_CHAT_SEND_URL, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      const { answer, threadId: newThreadId } = response.data;

      if (!threadId && newThreadId) {
        setThreadId(newThreadId);
      }

      const newEntry = {
        question: message,
        answer,
        folder: new Date().toISOString()
      };

      setChatMenu(prev => [...prev, newEntry]);
      return answer;
    } catch (error) {
      console.error('Error sending message:', error.message);
      throw error;
    }
  };

  return (
    <ChatContext.Provider value={{
      chatMenu, setChatMenu,
      chatMessage, setChatMessage,
      chatShow, setChatShow,
      showChatTime, setShowChatTime,
      threadId, setThreadId,
      responses, setResponses, // ✅ expuestos globalmente
      sendMessage
    }}>
      {children}
    </ChatContext.Provider>
  );
};

export { ChatContext, ChatProvider };
